/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiSchemaRetrieveLang =
  (typeof ApiSchemaRetrieveLang)[keyof typeof ApiSchemaRetrieveLang];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiSchemaRetrieveLang = {
  'da-dk': 'da-dk',
  'de-at': 'de-at',
  'de-ch': 'de-ch',
  'de-de': 'de-de',
  'en-ca': 'en-ca',
  'en-gb': 'en-gb',
  'en-ie': 'en-ie',
  'en-us': 'en-us',
  'es-es': 'es-es',
  'fi-fi': 'fi-fi',
  'fr-ca': 'fr-ca',
  'fr-fr': 'fr-fr',
  'it-it': 'it-it',
  'nb-no': 'nb-no',
  'nl-be': 'nl-be',
  'nl-nl': 'nl-nl',
  'pi-r8': 'pi-r8',
  'pl-pl': 'pl-pl',
  'sv-se': 'sv-se',
} as const;
